import React, { useState } from 'react';
import { Button, InputZIP } from '@nerdwallet/currency';
import useAnalytics from '~/app/lib/segment/useAnalytics';
import styles from './auto-insurance-entry-form.module.scss';
import SegmentImpression from '../../segment-impression';
import { HOMEPAGE_SEGMENT_INSTRUMENTATION } from '~/app/lib/analytics/analytics-constants';

const AutoInsuranceEntryForm = () => {
  const { trackSegmentTrackEvent } = useAnalytics();
  const zipCodePlaceholder = '94103';
  const ERROR_MESSAGE = 'Please enter a valid zip code';
  const [zipCode, setZipCode] = useState('');
  const [isValid, setIsValid] = useState(true);
  const ZIP_CODE_REGEX = '^[0-9]{5}$';

  const validateZipCode = (zipCode: string): boolean => {
    if (!zipCode) return false;
    return new RegExp(ZIP_CODE_REGEX).test(zipCode);
  };

  const trackZipCodeInputChange = (newZipCode: string) => {
    // Bedrock instrumentation tracking
    trackSegmentTrackEvent('us_location_updated', {
      form_name: 'hp_quiz_ins_entry_form',
      value_s: newZipCode,
      was_prefilled: false,
      is_valid: true,
      validation_failure_message: 'false',
      additional_attributes: {
        location_type: 'auto_location',
      },
    });
  };

  const validateZipCodeInput = (newZipCode: string) => {
    if (validateZipCode(newZipCode)) {
      setIsValid(true);
      trackZipCodeInputChange(newZipCode);
    } else {
      setIsValid(false);
    }
  };

  const handleInputChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    currentZipCode: string,
  ) => {
    if (e.target.value === currentZipCode) return;
    if (!e.target.value) {
      setZipCode(e.target.value);
      validateZipCodeInput(zipCodePlaceholder);
    } else {
      setZipCode(e.target.value);
      validateZipCodeInput(e.target.value);
    }
  };

  const redirectToAutoInsuranceFlow = () => {
    trackSegmentTrackEvent('Element Interaction', {
      entity_name: 'hp_quiz_ins_cta_click',
      location: HOMEPAGE_SEGMENT_INSTRUMENTATION.vertical_comparison.location,
      interaction_type: 'select',
    });
    window.open(
      'https://www.nerdwallet.com/insurance/auto/match?qsSrcId=664395',
      '_blank',
    );
  };

  return (
    <SegmentImpression
      eventName="Element Impression"
      eventProps={{
        entity_name: 'hp_quiz_ins_cta',
        location: HOMEPAGE_SEGMENT_INSTRUMENTATION.vertical_comparison.location,
      }}
    >
      <div className={styles.formContainer}>
        <span className={styles.formLabel}>Enter your ZIP code</span>
        <div className={styles.formRow}>
          <InputZIP
            className={styles.formInput}
            fullWidth
            error={!isValid}
            placeholder={zipCodePlaceholder}
            errorMessage={ERROR_MESSAGE}
            value={zipCode}
            onChange={(e) => {
              handleInputChange(e, zipCode);
            }}
            name="zipCode"
            label=""
          />
          <Button
            primary
            fullWidth
            className={styles.formButton}
            disabled={!isValid}
            onClick={redirectToAutoInsuranceFlow}
          >
            Get quotes
          </Button>
        </div>
      </div>
    </SegmentImpression>
  );
};

export default AutoInsuranceEntryForm;
